import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AssetCacheService {
  currentVersion: string = new Date().getTime().toString();
  constructor() {}

  public newContext() {
    this.currentVersion = new Date().getTime().toString();
  }
}
